/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/

var specific_header = {};

(function () {

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function () {

		/*
		Language switcher color
		*/
		if (
			url[2] == ''
		) {
			$('.js-header-language').removeClass('color-dark').addClass('color-light');
		} else {
			$('.js-header-language').removeClass('color-light').addClass('color-dark');
		}

		/*
		Comedy section
		Comedy section
		Comedy section
		Comedy section
		*/
		if (
			url[2] == 'comedy' &&
			header_loaded != 'comedy'
		) {

			/*
			XHR request
			*/
			$.ajax({
				url: globalUrl + '/' + _language + '/a/l/header/comedy',
				headers: {
					'go-load': 1
				}
			})
				.done(function (data) {

					$('header').html(data);
					$('header').removeClass('bats').addClass('comedy');

					if (
						$(window).width() < 768
					) {
						$('header').css({ left: 0 });
					} else {
						$('header').animate({ left: 0 }, 500, 'swing');
					}

					header_loaded = 'comedy';

					/*
					Set: Active item
					*/
					specific_interactions.catchAndActiveURL();

				})
				.always(function () {
				});

			/*
			XHR request
			*/
			$.ajax({
				url: globalUrl + '/' + _language + '/a/l/mobilemenu/comedy',
				headers: {
					'go-load': 1
				}
			})
				.done(function (data) {

					$('.js-mobile-menu').html(data);

					/*
					Set: Active item
					*/
					specific_interactions.catchAndActiveURL();

				})
				.always(function () {
				});

		}

		/*
		Vleermuis section
		Vleermuis section
		Vleermuis section
		Vleermuis section
		*/
		if (
			url[2] == 'vleermuis' &&
			header_loaded != 'vleermuis' ||
			url[2] == 'bats' &&
			header_loaded != 'vleermuis'
		) {

			/*
			XHR request
			*/
			$.ajax({
				url: globalUrl + '/' + _language + '/a/l/header/' + url[2],
				headers: {
					'go-load': 1
				}
			})
				.done(function (data) {

					$('header').html(data);
					$('header').removeClass('comedy').addClass('bats');

					if (
						$(window).width() < 768
					) {
						$('header').css({ left: 0 });
					} else {
						$('header').animate({ left: 0 }, 500, 'swing');
					}

					header_loaded = 'vleermuis';

					/*
					Set: Active item
					*/
					specific_interactions.catchAndActiveURL();

				})
				.always(function () {
				});

			/*
			XHR request
			*/
			$.ajax({
				url: globalUrl + '/' + _language + '/a/l/mobilemenu/' + url[2],
				headers: {
					'go-load': 1
				}
			})
				.done(function (data) {

					$('.js-mobile-menu').html(data);

					/*
					Set: Active item
					*/
					specific_interactions.catchAndActiveURL();

				})
				.always(function () {
				});

		}

		/*
		Homepage section
		Homepage section
		Homepage section
		Homepage section
		*/
		if (url[2] == '') {
			if (
				header_loaded == 'vleermuis' ||
				header_loaded == 'comedy'
			) {

				if (
					$(window).width() < 768
				) {

					$('header').removeClass('comedy bats').css({ left: '-22vw' }, function () {
						$('header').html('');
					});

				} else {

					$('header').removeClass('comedy bats').animate({ left: '-22vw' }, 0, function () {
						$('header').html('');
					});

				}

				header_loaded = 'none';

			}
		}

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_header); 